import React from "react"
import Layout from "../../components/layout"
import Hero from "../../components/hero"
import { Helmet } from "react-helmet"
import Img from "../../assets/images/bgHeroBusesUrbanos.jpg"
import { Wrapper } from "../../components/blogDesc/style"
const blog1 = () => {
  return (
    <>
      <Helmet>
        <title>Blog</title>
        <meta name="description" content="Descripcion de blog"></meta>
      </Helmet>
      <Layout>
        <Hero
          img={Img}
          title="F&aacute;brica de carrocer&iacute;as l&iacute;der en el sur del Per&uacute;: Intramet, la historia"
        ></Hero>
        <Wrapper>
          <div className="container">
            <img src={Img} alt="Imagen Principal de blog" />
            <h2>
              F&aacute;brica de carrocer&iacute;as l&iacute;der en el sur del
              Per&uacute;: Intramet, la historia
            </h2>
            <p>
              <strong>05 de Agosto 2021</strong>
            </p>
            <p>
              El sector carrocero de Arequipa funcionó por generaciones
              acumulando experiencia en carrocerías adaptables para las
              carreteras peruanas. Existían perfiles admirables de carroceros
              independientes tales como Agripino Coyuri.
            </p>
            <p>
              Mientras los carroceros del sur perfeccionaban sus técnicas, los
              del norte y de ciudades como Lima y Trujillo industrializaban su
              producción en serie, logrando precios competitivos y captando así
              la atención del mercado nacional.
            </p>
            <h2>Inicio de una carrera en carrocerías</h2>
            <p>
              Todo comenzó con Agripino Coyuri, quien se inició a los 17 años en
              el mundo de las carrocerías para el transporte de pasajeros.
            </p>
            <p>
              En el año 1967 su primer centro de trabajo fue la empresa “San
              Cristóbal Del Sur” donde desempeñó el cargo de ayudante.
            </p>
            <p>
              Al haber adquirido cierto grado de experiencia y en busca de más
              conocimiento (una característica que heredó a las futuras
              generaciones) pasó a formar parte de la empresa “Carrocerías
              Espinar” ubicada en el Palomar - Arequipa.
            </p>
            <h2>Consolidación de conocimiento y liderazgo</h2>
            <p>
              En los años 90 Agripino Coyuri consolida su alto grado de
              experiencia en la fabricación de carrocerías. Se convierte en Jefe
              de producción y pieza fundamental en la fundación en "Intramet
              S.A."
            </p>
            <p>
              Fueron ocho años de conocimiento, experiencias y alegrías al ser
              parte de una empresa próspera que lo acogió y confió en él para
              tener un cargo de responsabilidad.
            </p>
            <p>
              Por razones administrativas la empresa tuvo que cerrar sus
              puertas, lo que lejos de desanimar a nuestro fundador le dio la
              oportunidad de iniciar su etapa de emprendedor.
            </p>
            <h2>Etapa de emprendimiento</h2>
            <p>
              Pasar de técnico a jefe y finalmente a emprendedor, fue un camino
              que se dio de forma natural.
            </p>
            <p>
              En 1999 Agripino Coyuri pasó a formar parte de “INMECOT SRL”, una
              sociedad empresarial dedicada a la fabricación de carrocerías.
              Pero esto no quedó allí, en busca de nuevas oportunidades y junto
              a su familia decidió centrarse en algo propio.
            </p>
            <p>
              Así para el año 2002 lidera la constitución de la empresa
              “FECENTURY SRL”.
            </p>
            <p>
              Fueron cuatro años de aprendizaje llegando a la conclusión que el
              crecimiento de un negocio no sólo debe tener el mejor producto,
              sino también una buena gestión administrativa y comercial.
            </p>
            <h2>
              Inicio de Intramet, la Fábrica de Carrocerías líder del sur del
              Perú
            </h2>
            <p>
              “Para ser la mejor empresa del sur del Perú no solo tenían que ser
              los mejores carroceros, además tenían que adquirir visión
              empresarial”
            </p>
            <p>
              El 17 de Julio del 2006, de forma estratégica y aprovechando la
              coyuntura en el desarrollo y crecimiento del sector, se constituye
              la empresa “INTRAMET S.R.L.” con actividad económica en el rubro
              de reparación, mantenimiento y fabricación de carrocerías sobre
              chasis de las marcas más reconocidas tales como: SCANIA,VOLVO y
              MERCEDES BENZ.
            </p>
            <p>
              Se eligió este nombre en honor a la primera empresa carrocera que
              confió en Agripino Coyuri para ser líder de la línea de
              fabricación. Y en el año 2011 se compró la planta de producción de
              “INTRAMET SRL”, donde se encuentra hasta el día de hoy.
            </p>
            <h2>Etapa de evolución, tiempo de reinventarse</h2>
            <p>
              En el transcurso de los años cambiaron las expectativas del
              mercado y no bastaba tener únicamente un vehículo de buena
              calidad,además tenía que tener un diseño tan atractivo como los
              vehículos importados.
            </p>
            <p>
              En esta necesidad de evolucionar para mantenerse competitivos es
              que nacen los primeros modelos de la serie Olympo.
            </p>
            <p>
              El año 2016 fue muy importante para “INTRAMET SRL” debido a un
              incendio, donde se perdieron todos los moldes y las matrices de
              las carrocerías. Fueron momentos difíciles, pero al mismo tiempo
              fue la oportunidad que se necesitaba para innovar.
            </p>
            <p>
              Se dejaron atrás los patrones obsoletos y este evento fue la
              motivación para dar paso a la reinvención de diseños y acabados.
            </p>
            <p>
              Se renueva la serie Olympo y toma fuerza y reconocimiento en el
              mercado.
            </p>
            <p>
              Durante los últimos años y algo más de experiencia administrativa
              y comercial se organizaron estrategias de posicionamiento y
              reconocimiento a los colaboradores.
            </p>
            <p>
              En el 2018 se organizó el evento de “Imposición de Cascos” para
              nombrar a los jefes de cada área. Este evento significó la
              oportunidad de brindarles reconocimiento a nuestros colaboradores
              y entregarles cargos de confianza.
            </p>
            <p>
              En los siguientes años “INTRAMET SRL” participó de ferias para
              mostrar la calidad de de las carrocerías, dando inicio a la fase
              comercial y de difusión.
            </p>
            <h2>¿Qué es lo que trae el futuro para Intramet?</h2>
            <p>
              Somos una empresa que lleva en su ADN el emprendimiento y
              excelencia.
            </p>
            <p>
              INTRAMET SRL se enorgullece de sus raíces y apuesta por capacitar
              y empoderar a sus trabajadores desde el inicio de sus actividades
              tanto en habilidades técnicas como blandas.
            </p>
            <p>
              Lo que viene a continuación es más crecimiento con visión
              empresarial a largo plazo, llevar los vehículos al norte del Perú.
              Seguir evolucionando, seguirle el paso a este mercado competitivo
              y cambiante.
            </p>
          </div>
        </Wrapper>
      </Layout>
    </>
  )
}

export default blog1
